import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/cross.svg'


const _hoisted_1 = { class: "opModal formContainer" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "body" }
const _hoisted_7 = { class: "mt-4" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-sm-6" }
const _hoisted_10 = { class: "col-sm-6" }
const _hoisted_11 = { class: "col-sm-6" }
const _hoisted_12 = { class: "d-block" }
const _hoisted_13 = { class: "text-center mt-5" }
const _hoisted_14 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_form_field = _resolveComponent("form-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_localized_text, {
          localizedKey: "Edit Configuration",
          text: "Edit Configuration"
        })
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-modal-close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_form_field, {
              type: "text",
              labelKey: "Production Phase",
              labelValue: "Production Phase",
              placeholderKey: "Production Phase",
              placeholderValue: "Production Phase",
              modelValue: _ctx.localModel.productionPhase,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localModel.productionPhase) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_form_field, {
              type: "number",
              labelKey: "Position",
              labelValue: "Position",
              placeholderKey: "Position",
              placeholderValue: "Position",
              modelValue: _ctx.localModel.position,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localModel.position) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", {
              class: "form-group pointer w-100 ms-2",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.localModel.showWastage = !_ctx.localModel.showWastage))
            }, [
              _createElementVNode("label", _hoisted_12, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Show Wastage Percentage",
                  text: "Show Wastage Percentage"
                })
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["sameAsCheckbox me-2", {'active': _ctx.localModel.showWastage}])
              }, null, 2)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-tertiary",
          disabled: !_ctx.canSave,
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
        }, [
          (!_ctx.localModel.identifier)
            ? (_openBlock(), _createBlock(_component_localized_text, {
                key: 0,
                localizedKey: "Create",
                text: "Create"
              }))
            : (_openBlock(), _createBlock(_component_localized_text, {
                key: 1,
                localizedKey: "Edit",
                text: "Edit"
              }))
        ], 8, _hoisted_14)
      ])
    ])
  ]))
}